import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

const dismissedKeys = new Set()

export default class CoachMarkController extends Controller {
  static values = {
    key: String,
    dismissed: { type: Boolean, default: false },
    text: { type: String, default: '' }
  }

  connect () {
    if (this.dismissedValue || dismissedKeys.has(this.keyValue)) return
    this.#renderIndicator()
    this.element.addEventListener('click', this.handleHostClick)
  }

  disconnect () {
    this.element.removeEventListener('click', this.handleHostClick)
    this.#removeIndicator()
  }

  handleHostClick = () => {
    this.#dismiss()
  }

  dismissFromIndicator = (event) => {
    event.preventDefault()
    event.stopPropagation()
    this.#dismiss()
  }

  // ---- private ----

  #renderIndicator () {
    if (this.indicator) return

    const wrapper = document.createElement('span')
    wrapper.className = 'coach-mark'
    wrapper.setAttribute('aria-hidden', 'true')

    const pulse = document.createElement('span')
    pulse.className = 'coach-mark__pulse'

    if (this.textValue) {
      pulse.dataset.controller = 'tooltip'
      pulse.dataset.tooltipContentValue = this.textValue
      pulse.dataset.tooltipPlacementValue = 'right'
    }

    wrapper.appendChild(pulse)
    wrapper.addEventListener('click', this.dismissFromIndicator)

    // Make the host element a positioning context if it isn't already.
    const hostPosition = window.getComputedStyle(this.element).position
    if (hostPosition === 'static') {
      this.element.style.position = 'relative'
    }
    this.element.appendChild(wrapper)
    this.indicator = wrapper
  }

  #removeIndicator () {
    if (!this.indicator) return
    this.indicator.remove()
    this.indicator = null
  }

  #dismiss () {
    if (this.dismissedValue || dismissedKeys.has(this.keyValue)) return
    this.dismissedValue = true
    dismissedKeys.add(this.keyValue)
    this.#removeIndicator()
    this.#postDismiss()
  }

  #postDismiss () {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    return fetch('/onboarding/coach_marks/dismiss', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': csrf || ''
      },
      body: JSON.stringify({ key: this.keyValue })
    }).catch((error) => {
      console.warn('[coach-mark] dismiss POST failed', error)
    })
  }
}

stimulus.register('coach-mark', CoachMarkController)
